<template>
  <v-list-group
    ref="refVListGroup"
    class="vertical-nav-menu-group text--primary"
    :value="value"
    @input="$emit('input', $event)"
  >
    <template v-if="icon" #prependIcon>
      <v-icon :class="{'alternate-icon-small': !icon}">
        {{ icon }}
      </v-icon>
    </template>
    <template #activator>
      <v-list-item-title>
        {{ title }}
      </v-list-item-title>
    </template>
    <slot></slot>
  </v-list-group>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: undefined,
    },
  },

  setup() {
    return {}
  },
}
</script>

<style lang="scss">
.app-navigation-menu {
  .v-list-item {
    padding-left: 22px;
    margin-top: 0;
    height: 35px;
    min-height: 35px;

    .v-list-item__icon {
      margin-top: 0;
      margin-bottom: 0;
      align-self: center;
    }
  }

  @include theme(v-list-group__header) using ($material) {
    &.v-list-item--active {
      background-color: rgba(map-deep-get($material, 'text', 'primary'), map-deep-get($material, 'states', 'selected'));
    }
  }

  .vertical-nav-menu-group {
    > .v-list-group__header .v-list-item__title {
      font-size: 0.83rem !important;
      font-weight: 900 !important;
    }

    .v-list-group__items .vertical-nav-menu-link {
      padding-left: 23px;

      .v-list-item__title {
        font-size: 0.83rem;
      }
    }

    & > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
      transform: rotate(-90deg);
    }

    &.v-list-group--active > .v-list-group__header > .v-list-group__header__append-icon .v-icon {
      transform: none;
    }
  }
}
</style>
